import React from "react";
import ProductCard from "./ProductCard";

const RelatedProducts = ({ products, title = "You Might Also Like", testId = "related-products", limit = 4 }) => {
  if (!products.length) return null;
  return (
    <section className="mt-14 px-4 md:mt-16 md:px-8 lg:px-12" data-testid={testId}>
      <h2 className="mb-5 font-anton text-[clamp(2rem,8vw,3rem)] uppercase leading-none md:text-5xl">{title}</h2>
      <div className="grid auto-rows-fr grid-cols-1 gap-3 min-[390px]:grid-cols-2 md:grid-cols-3 md:gap-2.5 lg:grid-cols-4 lg:gap-2.5 min-[1440px]:grid-cols-5 min-[1440px]:gap-2.5">
        {products.slice(0, limit).map((product) => <ProductCard key={product.id} product={product} />)}
      </div>
    </section>
  );
};

export default RelatedProducts;
